import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';

import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  showResetPassword = false;

  clientId: any;
  clientSecret: any;
  constructor(
    public fb: FormBuilder,
    public memberService: MemberService,
    public helperService: HelperService,
    public title: Title
  ) {
    this.clientId = environment.clientId;
    this.clientSecret = environment.clientSecret;
  }

  ngOnInit() {
    this.forgotPasswordFormInit();
  }

  forgotPasswordFormInit() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]]
    });
  }

  submit(value) {
    if (!this.forgotPasswordForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.resetPassword(data);
  }

  resetPassword(data) {
    data.client_id = this.clientId;
    data.client_secret = this.clientSecret;
    data = this.helperService.updateJsonFormat(data);
    this.memberService.forgotPassword(data).subscribe(response => {
      this.successMsg = 'Password reset link has been sent in email.';
      setTimeout(() => {
        this.showResetPassword = true;
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.message) {
      this.errorMsg = err.error.message;
    } else {
      this.errorMsg = 'Unable to change password this time.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

}
